import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store/'
// import CampaignSelection from '@/components/campaigns/selection.vue'
import GroupSelection from '@/components/campaigns/group.vue'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/setup/',
      name: 'SetUp',
      component: () => import('@/views/setup/index.vue'),
      meta: { hideSidebar: true }
    },
    {
      path: '/landing/',
      name: 'Übersicht',
      component: () => import('@/views/landing/index.vue')
    },
    {
      path: '/data/',
      name: 'Offline-Daten',
      component: () => import('@/views/data/index.vue'),
      redirect: '/data/environment/',
      children: [
        {
          path: 'environment',
          component: () => import('@/views/data/environment/index.vue')
        },
        {
          path: 'map',
          component: () => import('@/views/data/map/index.vue')
        },
        {
          path: 'tracing',
          component: () => import('@/views/data/tracing/index.vue')
        }
      ]
    },
    {
      path: '/settings/',
      name: 'Einstellungen',
      component: () => import('@/views/settings/index.vue'),
      redirect: '/settings/device/',
      children: [
        {
          path: 'device',
          component: () => import('@/views/settings/device/index.vue')
        },
        {
          path: 'display',
          component: () => import('@/views/settings/display/index.vue')
        },
        {
          path: 'tracing',
          component: () => import('@/views/settings/tracing/index.vue')
        },
        {
          path: 'sync',
          component: () => import('@/views/settings/sync/index.vue')
        },
        {
          path: 'server',
          component: () => import('@/views/settings/server/index.vue')
        }
      ]
    },
    {
      path: '/device/',
      name: 'Geräte-Informationen',
      component: () => import('@/views/device/index.vue')
    },
    {
      path: '/map/',
      name: 'freie Schlagkarte',
      component: () => import('@/views/map/index.vue'),
      meta: { hideSidebar: true }
    },
    {
      path: '/campaigns/',
      name: 'Kampagnen',
      component: () => import('@/views/campaigns/index.vue'),
      props: true,
      children: [
        {
          path: '',
          name: 'Kampagnen-Auswahl',
          component: () => import('@/components/campaigns/selection.vue')
        },
        {
          path: ':campaignID',
          name: 'Kampagnen-Arbeitsmittel',
          component: () => import('@/views/campaigns/equipment/index.vue')
        },
        {
          path: ':campaignID/:equipmentID',
          name: 'Kampagnen-Feld-Gruppen',
          component: GroupSelection
        }
      ]
    },
    {
      path: '/campaigns/:campaignID/:equipmentID/:groupID/',
      name: 'Kampagnen - Schlagkarte',
      component: () => import('@/views/campaigns/map/index.vue'),
      props: true
    },
    {
      path: '/manually/',
      name: 'Handarbeit',
      component: () => import('@/views/manually/index.vue'),
      props: true,
      children: [
        {
          path: '',
          name: 'Handarbeit-Auswahl',
          component: () => import('@/components/campaigns/selection.vue')
        },
        {
          path: ':campaignID',
          name: 'Handarbeit-Arbeitsmittel',
          component: () => import('@/views/manually/equipment/index.vue')
        },
        {
          path: ':campaignID/:multiEquipmentID',
          name: 'Handarbeit-Feld-Gruppen',
          component: GroupSelection
        }
      ]
    },
    {
      path: '/manually/:campaignID/:multiEquipmentID/:groupID/',
      name: 'Handarbeit - Schlagkarte',
      component: () => import('@/views/manually/map/index.vue'),
      meta: { hideSidebar: true },
      props: true
    },
    { path: '/:pathMatch(.*)', redirect: '/landing/' }
  ]
})

router.beforeEach((to, from) => {
  // Not Authenticated
  if (!store.state.settings.instance) {
    if (to.path === '/setup/') return true
    if (from.path === '/setup/') return false
    return '/setup/'
  }

  return true
})

export default router
